export type FeedItem = {
  id: number;
  category: string;
  tag: string;
  title: string;
  summary: string;
  image: string;
  heat: string;
  time: string;
  views: string;
  comments: number;
  hot?: boolean;
};

export type HotTopic = {
  rank: number;
  title: string;
  level: string;
  levelColor: string;
  heat: string;
};

export const categories = [
  { key: "全部", label: "全部新瓜" },
  { key: "明星", label: "明星动态" },
  { key: "网红", label: "网红生态" },
  { key: "综艺", label: "综艺热梗" },
  { key: "社会", label: "社会趣闻" },
];

export const feedItems: FeedItem[] = [
  {
    id: 1,
    category: "明星",
    tag: "热点",
    title: "实力派演员新片口碑爆棚，首映礼主创齐亮相互动",
    summary: "影片点映口碑发酵迅速，现场主创回顾幕后创作历程，并透露续作筹备中，引发影迷热烈期待与二刷热潮。",
    image: "https://readdy.ai/api/search-image?query=a%20cinema%20premiere%20event%20scene%20with%20bright%20stage%20spotlights%2C%20red%20carpet%20glow%20and%20film%20reel%20decorations%2C%20warm%20coral%20and%20watermelon%20red%20tones%2C%20cinematic%20editorial%20lighting%2C%20no%20faces%2C%20atmosphere%20focus&width=800&height=560&seq=feed-star-01&orientation=landscape",
    heat: "4.2万",
    time: "8 分钟前",
    views: "1.8万",
    comments: 126,
    hot: true,
  },
  {
    id: 2,
    category: "网红",
    tag: "速递",
    title: "百万粉博主转型生活记录，评论区风向悄然变化",
    summary: "从夸张剧情向松弛日常转变后，粉丝互动率明显回升。业内人士分析流量逻辑改变背后的内容生态信号。",
    image: "https://readdy.ai/api/search-image?query=cozy%20room%20with%20ring%20light%2C%20camera%20tripod%20and%20smartphone%20screen%20showing%20recording%2C%20fresh%20green%20and%20cream%20tone%20interior%2C%20modern%20influencer%20studio%2C%20soft%20natural%20light%2C%20no%20people&width=800&height=560&seq=feed-net-02&orientation=landscape",
    heat: "3.1万",
    time: "24 分钟前",
    views: "9600",
    comments: 87,
  },
  {
    id: 3,
    category: "综艺",
    tag: "热梗",
    title: "新一季竞演综艺名场面出圈，导师点评引发全网共鸣",
    summary: "一段关于“作品与人气”的金句点评被反复剪辑传播，网友纷纷二创，成为本期讨论度最高的热议话题。",
    image: "https://readdy.ai/api/search-image?query=colorful%20talent%20show%20stage%20with%20glowing%20neon%20arches%20and%20audience%20silhouettes%2C%20warm%20pink%20and%20coral%20lighting%2C%20live%20entertainment%20atmosphere%2C%20cinematic%2C%20no%20clear%20faces&width=800&height=560&seq=feed-vari-03&orientation=landscape",
    heat: "2.6万",
    time: "1 小时前",
    views: "1.2万",
    comments: 210,
  },
  {
    id: 4,
    category: "社会",
    tag: "速递",
    title: "城市夜市新玩法爆火，年轻人打卡式消费带动商圈",
    summary: "集美食、手作与快闪演出于一体的夜市成为周末热门去处，商家排起长队，带动周边商圈人流明显回升。",
    image: "https://readdy.ai/api/search-image?query=vibrant%20night%20market%20street%20with%20hanging%20lanterns%2C%20food%20stalls%20and%20warm%20glowing%20lights%2C%20crowded%20lively%20atmosphere%2C%20watermelon%20red%20and%20amber%20tones%2C%20no%20specific%20faces&width=800&height=560&seq=feed-soc-04&orientation=landscape",
    heat: "2.2万",
    time: "2 小时前",
    views: "8100",
    comments: 64,
  },
  {
    id: 5,
    category: "明星",
    tag: "热点",
    title: "国民综艺常青树官宣阵容，老将回归引发情怀杀",
    summary: "时隔多年核心成员重新合体，首支先导预告放出即冲上热搜，网友直呼“青春回来了”，期待值拉满。",
    image: "https://readdy.ai/api/search-image?query=retro%20variety%20show%20stage%20with%20warm%20spotlight%20and%20memorabilia%20display%2C%20nostalgic%20golden%20and%20coral%20tones%2C%20cinematic%20backstage%20feel%2C%20no%20faces&width=800&height=560&seq=feed-star-05&orientation=landscape",
    heat: "1.9万",
    time: "3 小时前",
    views: "7200",
    comments: 143,
  },
  {
    id: 6,
    category: "网红",
    tag: "深度",
    title: "带货直播间里的“剧本化叙事”为何屡试不爽",
    summary: "从低价秒杀到情感讲述，直播间话术不断迭代。这篇拆解了套路背后用户为何愿意一次次下单的心理机制。",
    image: "https://readdy.ai/api/search-image?query=modern%20live%20streaming%20studio%20with%20product%20shelves%2C%20warm%20lighting%20and%20green%20screen%2C%20fresh%20green%20and%20cream%20palette%2C%20clean%20ecommerce%20scene%2C%20no%20people&width=800&height=560&seq=feed-net-06&orientation=landscape",
    heat: "1.5万",
    time: "5 小时前",
    views: "5300",
    comments: 39,
  },
  {
    id: 7,
    category: "综艺",
    tag: "盘点",
    title: "那些年刷屏的综艺金句，你还记得几句？",
    summary: "一句台词足以点燃一个夏天。盘点十年间出圈综艺名场面，看看哪一句曾让你转发到朋友圈刷屏。",
    image: "https://readdy.ai/api/search-image?query=collage%20of%20tv%20screen%20and%20speech%20bubbles%20on%20warm%20gradient%20background%2C%20memes%20and%20catchphrases%20mood%2C%20coral%20and%20melon%20green%2C%20playful%20editorial%20design&width=800&height=560&seq=feed-vari-07&orientation=landscape",
    heat: "1.3万",
    time: "6 小时前",
    views: "6100",
    comments: 95,
  },
  {
    id: 8,
    category: "社会",
    tag: "速递",
    title: "“反向旅游”火了：年轻人开始躲进小城慢生活",
    summary: "避开人潮扎堆，越来越多上班族选择冷门小城躺平式度假。这场关于旅行方式的风向转变，正在改写文旅版图。",
    image: "https://readdy.ai/api/search-image?query=quiet%20ancient%20town%20alley%20in%20early%20morning%20with%20soft%20sunlight%20and%20greenery%2C%20serene%20slow%20travel%20mood%2C%20fresh%20green%20and%20cream%20tones%2C%20no%20people&width=800&height=560&seq=feed-soc-08&orientation=landscape",
    heat: "1.1万",
    time: "7 小时前",
    views: "4800",
    comments: 51,
  },
  {
    id: 9,
    category: "明星",
    tag: "速递",
    title: "演唱会经济持续升温，音乐节档期抢到排到明年",
    summary: "线下演出市场全面回暖，热门歌手巡演门票秒空。行业观察显示内容品质与体验服务正成为新一轮竞争关键。",
    image: "https://readdy.ai/api/search-image?query=huge%20concert%20crowd%20with%20glowing%20light%20sticks%20and%20confetti%20in%20the%20air%2C%20warm%20coral%20and%20magenta%20stage%20lights%2C%20energetic%20live%20music%20atmosphere%2C%20cinematic%20wide%20shot&width=800&height=560&seq=feed-star-09&orientation=landscape",
    heat: "9800",
    time: "9 小时前",
    views: "4600",
    comments: 78,
  },
];

export const hotTopics: HotTopic[] = [
  { rank: 1, title: "实力派演员新片口碑爆棚", level: "爆", levelColor: "bg-primary-500", heat: "12.4万热度" },
  { rank: 2, title: "老牌综艺核心阵容回归合体", level: "沸", levelColor: "bg-primary-400", heat: "9.8万热度" },
  { rank: 3, title: "竞演舞台导师金句出圈", level: "热", levelColor: "bg-secondary-500", heat: "8.1万热度" },
  { rank: 4, title: "百万粉博主转型松弛记录", level: "热", levelColor: "bg-secondary-500", heat: "6.7万热度" },
  { rank: 5, title: "反向旅游带动小城出圈", level: "新", levelColor: "bg-accent-500", heat: "5.2万热度" },
  { rank: 6, title: "演唱会经济全面升温", level: "热", levelColor: "bg-secondary-500", heat: "4.6万热度" },
  { rank: 7, title: "夜市新玩法带火商圈", level: "新", levelColor: "bg-accent-500", heat: "3.9万热度" },
  { rank: 8, title: "直播间剧本化叙事拆解", level: "新", levelColor: "bg-accent-500", heat: "3.1万热度" },
  { rank: 9, title: "综艺名场面十年盘点", level: "热", levelColor: "bg-secondary-500", heat: "2.8万热度" },
  { rank: 10, title: "年轻人躲进小城慢生活", level: "热", levelColor: "bg-secondary-500", heat: "2.2万热度" },
];

export const deepReads = [
  {
    id: "d1",
    category: "深度盘点",
    title: "从爆红到长红：网红流量逻辑正在被重写",
    description: "当“一夜爆红”越来越频繁，人们也开始追问：谁能在喧嚣里留下来？我们梳理了内容生态的几大变化，看看长红者做对了什么。",
    image: "https://readdy.ai/api/search-image?query=abstract%20rising%20flame%20and%20growing%20plant%20concept%20on%20soft%20watermelon%20gradient%2C%20metaphor%20of%20overnight%20fame%20and%20long%20term%20growth%2C%20editorial%20minimal%2C%20coral%20green%20cream&width=1000&height=640&seq=deep-01&orientation=landscape",
    readTime: "6 分钟",
    views: "4.3万",
  },
  {
    id: "d2",
    category: "现场观察",
    title: "一场音乐节到底如何拉动一座城的经济",
    description: "从门票到酒店再到小吃街，一场演出的涟漪远比你想象的大。用真实数据拆解“演出+文旅”背后的城市生意经。",
    image: "https://readdy.ai/api/search-image?query=festival%20stage%20with%20light%20beams%20and%20city%20skyline%20silhouette%20at%20dusk%2C%20warm%20magenta%20and%20golden%20sky%2C%20wide%20cinematic%20landscape%2C%20no%20faces&width=1000&height=640&seq=deep-02&orientation=landscape",
    readTime: "5 分钟",
    views: "2.9万",
  },
  {
    id: "d3",
    category: "行业研究",
    title: "年轻人为什么开始集体“反向”消费",
    description: "拒绝溢价、回归体验、更愿意为情绪买单——新一代消费观的转变背后，是一整套价值排序的重构。看懂这些，就读懂了市场。",
    image: "https://readdy.ai/api/search-image?query=minimalist%20flat%20lay%20of%20shopping%20bags%2C%20coins%20and%20green%20leaves%20on%20cream%20surface%2C%20conscious%20consumption%20theme%2C%20fresh%20green%20accent%2C%20clean%20editorial&width=1000&height=640&seq=deep-03&orientation=landscape",
    readTime: "7 分钟",
    views: "3.6万",
  },
];

export const hotSearchWords = [
  "舞台金句",
  "合体回归",
  "反向旅游",
  "口播带货",
  "新片首映",
  "松弛感",
  "夜市经济",
  "巡演抢票",
  "综艺盘点",
  "慢生活",
];

export const faqs = [
  {
    q: "色瓜网每天什么时候更新内容？",
    a: "色瓜网采用每日滚动更新的方式，从早间新闻到深夜热点，全天多时段推送新鲜瓜点。工作日以娱乐行业动态为主，周末则会增加综艺名场面与社会趣闻的盘点内容。",
  },
  {
    q: "如何快速找到我想看的那条瓜？",
    a: "你既可以使用顶部搜索框输入关键词检索，也可以点击首页的“热搜词”或通过栏目分类（明星动态、网红生态、综艺热梗、社会趣闻）来精准筛选，系统会即时为你过滤匹配内容。",
  },
  {
    q: "站内的热度数值是如何统计的？",
    a: "热度综合了内容的讨论量、互动量与传播速度，由系统在固定时间窗内动态计算得出，仅用于呈现内容受关注程度，帮助读者判断哪些话题正在快速升温。",
  },
  {
    q: "我可以在评论区讨论或分享我的看法吗？",
    a: "当然可以。我们鼓励理性、友善的交流与观点碰撞，同时也请遵守基本的发言规范：尊重他人、不造谣传谣、不进行人身攻击，共同维护良好的讨论氛围。",
  },
  {
    q: "看到感兴趣的内容，可以转发分享给朋友吗？",
    a: "欢迎分享。你可以将喜欢的文章或热门话题一键分享到微信、微博等社交平台，和好友一起围观讨论这场正在发生的网络热点。",
  },
];